

export function parseTestEndpointData(endpoint, body, filters) {

    

    return {
        id: endpoint.id,
        key: endpoint.key,
        endpoint: endpoint,
        url: endpoint.url,
        body: body,
        filters: filters,
    }
}